import { Constants } from '../utils/constants';

/**
 * 10GアップグレードのSTS（開通状態）を判定する
 * 工事の開通状態をもとに、STS済み（STSOK）または未STS（NOTSTSNG）を返す。
 *
 * @param is_open_cnst 開通状態フラグ（APIレスポンスから取得）
 * @returns STS判定結果の定数
 */
export const judgeSTS = (is_open_cnst: string) => {
  const stsupgrade = is_open_cnst;

  if (stsupgrade) {
    // 開通済みの場合
    if (stsupgrade === Constants.UpgradesearchSTS.STS) {
      return Constants.STS.STSOK;
    }
    // 未開通の場合
    if (stsupgrade === Constants.UpgradesearchSTS.NOTSTS) {
      return Constants.STS.NOTSTSNG;
    }
  }
  // 状態が未設定の場合は未開通として扱う
  return Constants.STS.NOTSTSNG;
};

export default judgeSTS;
